import React, { useEffect, useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebookF,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import { faX } from "@fortawesome/free-solid-svg-icons";
import Aos from "aos";
import "aos/dist/aos.css";
import Alert from "./Alert";

const Footer = () => {
  useEffect(() => {
    Aos.init({ duration: 100 });
  }, []);

  const [email, setEmail] = useState("");
  const [alert, setAlert] = useState({ status: "", message: "" });

  const year = new Date().getFullYear();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "http://localhost:3001/api/v1/mail/subscribe",
        {
          email,
        }
      );
      console.log(response.data.message);
      setAlert({ status: "success", message: "Subscribed successfully" });
      setEmail("");
    } catch (error) {
      setAlert({ status: "error", message: "Failed to subscribe" });
    }
  };

  return (
    <div>
      {alert.message && (
        <Alert
          status={alert.status}
          message={alert.message}
          onClose={() => setAlert({ status: "", message: "" })}
        />
      )}

      <footer className="bg-primary text-white py-24 px-16">
        <div
          // data-aos="fade-in"
          // data-aos-duration="1000"
          className="container mx-auto flex flex-col lg:flex-row justify-between items-start space-y-8 lg:space-y-0 lg:space-x-12"
        >
          {/* Logo and Slogan */}
          <div className="flex flex-col items-center lg:items-start w-full lg:w-auto">
            <img
              src="/images/logo.png"
              alt="SAWA Logo"
              className="w-40 mb-2 lg:w-48"
            />
            <p className="text-lg text-center lg:text-left">
              Protecting wildlife through art
            </p>
            {/* Social Media Icons */}
            <div className="flex space-x-3 justify-center lg:justify-start mt-7">
              <a
                href="/"
                className="flex items-center justify-center w-10 h-10 border border-white text-white rounded-full"
              >
                <FontAwesomeIcon icon={faX} className="text-sm" />
              </a>
              <a
                href="/"
                className="flex items-center justify-center w-10 h-10 border border-white text-white rounded-full"
              >
                <FontAwesomeIcon icon={faInstagram} className="text-sm" />
              </a>
              <a
                href="/"
                className="flex items-center justify-center w-10 h-10 border border-white text-white rounded-full"
              >
                <FontAwesomeIcon icon={faFacebookF} className="text-sm" />
              </a>
              <a
                href="/"
                className="flex items-center justify-center w-10 h-10 border border-white text-white rounded-full"
              >
                <FontAwesomeIcon icon={faLinkedinIn} className="text-sm" />
              </a>
            </div>
          </div>

          {/* Company Links */}
          <div className="text-center lg:text-left w-full lg:w-auto">
            <h3 className="font-bold mb-3 text-xl lg:text-2xl">Company</h3>
            <ul className="space-y-2">
              <li>
                <a href="/conservation" className="hover:underline">
                  Conservation
                </a>
              </li>
              <li>
                <a href="/about-sawa" className="hover:underline">
                  About Us
                </a>
              </li>
              <li>
                <a href="/services" className="hover:underline">
                  Services
                </a>
              </li>
              <li>
                <a href="/contact" className="hover:underline">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Support Links */}
          <div className="text-center lg:text-left w-full lg:w-auto">
            <h3 className="font-bold mb-3 text-xl lg:text-2xl">Support</h3>
            <ul className="space-y-2">
              <li>
                <a href="/sawa/faq" className="hover:underline">
                  FAQs
                </a>
              </li>
              <li>
                <a href="/sawa/privacy-policy" className="hover:underline">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/sawa/terms-and-conditions"
                  className="hover:underline"
                >
                  Terms And Conditions
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter Signup */}
          <div className="text-center lg:text-left max-w-xs lg:max-w-sm w-full lg:w-auto mx-auto">
            <h3 className="font-bold mb-3 text-xl lg:text-2xl">
              Stay Up To Date With SAWA
            </h3>
            <p className="mb-3 text-sm lg:text-base">
              Stay up to date with our latest news, campaigns, exciting events,
              artworks and other ways to get involved in conservation of
              wildlife.
            </p>
            <form
              onSubmit={handleSubmit}
              className="flex flex-col lg:flex-row text-black"
            >
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="p-2 rounded-l-md w-full lg:w-auto flex-grow mb-2 lg:mb-0 lg:mr-2"
              />
              <button
                type="submit"
                className="bg-secondary text-white p-2 rounded-r-md w-full lg:w-auto font-poppins font-semibold"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </footer>
      <div className="mx-auto text-center text-white bg-primary tracking-widest font-extralight py-3">
        <p>&copy; {year} SAWA. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
